import { render, staticRenderFns } from "./CertificateCenterCertificateSelectbox.vue?vue&type=template&id=545bcd64"
import script from "./CertificateCenterCertificateSelectbox.vue?vue&type=script&lang=js"
export * from "./CertificateCenterCertificateSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports